/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckRevertBedChangeEligibility200ResponseData
 */
export interface CheckRevertBedChangeEligibility200ResponseData {
    /**
     * Whether the bed change can be reverted
     * @type {boolean}
     * @memberof CheckRevertBedChangeEligibility200ResponseData
     */
    can_revert?: boolean;
    /**
     * Name of the previous bed
     * @type {string}
     * @memberof CheckRevertBedChangeEligibility200ResponseData
     */
    previous_bed_name?: string;
    /**
     * ID of the previous bed (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedChangeEligibility200ResponseData
     */
    previous_bed_id?: string;
    /**
     * Name of the current bed (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedChangeEligibility200ResponseData
     */
    current_bed_name?: string;
    /**
     * Date when the bed change occurred (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedChangeEligibility200ResponseData
     */
    bed_change_date?: string;
    /**
     * Reason why the bed change cannot be reverted (present when can_revert is false)
     * @type {string}
     * @memberof CheckRevertBedChangeEligibility200ResponseData
     */
    reason?: string;
}

/**
 * Check if a given object implements the CheckRevertBedChangeEligibility200ResponseData interface.
 */
export function instanceOfCheckRevertBedChangeEligibility200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckRevertBedChangeEligibility200ResponseDataFromJSON(json: any): CheckRevertBedChangeEligibility200ResponseData {
    return CheckRevertBedChangeEligibility200ResponseDataFromJSONTyped(json, false);
}

export function CheckRevertBedChangeEligibility200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRevertBedChangeEligibility200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'can_revert': !exists(json, 'can_revert') ? undefined : json['can_revert'],
        'previous_bed_name': !exists(json, 'previous_bed_name') ? undefined : json['previous_bed_name'],
        'previous_bed_id': !exists(json, 'previous_bed_id') ? undefined : json['previous_bed_id'],
        'current_bed_name': !exists(json, 'current_bed_name') ? undefined : json['current_bed_name'],
        'bed_change_date': !exists(json, 'bed_change_date') ? undefined : json['bed_change_date'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function CheckRevertBedChangeEligibility200ResponseDataToJSON(value?: CheckRevertBedChangeEligibility200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'can_revert': value.can_revert,
        'previous_bed_name': value.previous_bed_name,
        'previous_bed_id': value.previous_bed_id,
        'current_bed_name': value.current_bed_name,
        'bed_change_date': value.bed_change_date,
        'reason': value.reason,
    };
}

